import * as React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from 'primereact/button';
import DropdownApi from '../../components/DropdownApi';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Grid } from '@mui/material';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { SelectButton } from 'primereact/selectbutton';
import { addRiskAssessment, updateRiskAssessment } from '../../service/riskAssessmentService';
import { Calendar } from 'primereact/calendar';
import {Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState} from "react";
import {addDocument, updateDocument} from "../../service/documentsService";
import Stack from "@mui/joy/Stack";
import Input from "@mui/joy/Input";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import {InputSwitch} from "primereact/inputswitch";
import {Column, ColumnEditorOptions} from "primereact/column";
import {DataTable, DataTableRowEditCompleteEvent} from "primereact/datatable";
import {dropdownViewGet} from "../../service/api-service";
import CloseIcon from "@mui/icons-material/Close";


export type ClientOverride = {
  client_id: string,
  frequency: string,
}
interface inputProps {
  clientOverrides: ClientOverride[],
  onChange: (clientOverrides: ClientOverride[]) => void
  toast: MutableRefObject<any>,
}

export default function FormAllocationAddClientOverrides(props: inputProps) {

  // const [clientOverrides, setClientOverrides] = useState([] as ClientOverride[]);
  const [loading, setLoading] = useState(false);
  const [editingRows, setEditingRows] = useState<Record<string, any>>({}); //{"-1": true}
  const [clientOverrides, setClientOverrides] = useState<ClientOverride[]>([]);
  const [clients, setClients] = useState<{id: string, name: string}[]>([]);

  const frequencies = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Yearly', value: 'yearly' },
  ];

  useEffect(() => {
    setLoading(true);

    dropdownViewGet("client").then(data => {
      setClients(data);
    }).catch((error) => {
      console.log("error == ", error);
      setClients([]);
    }).finally(() => {
      setClientOverrides(props.clientOverrides);
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    props.onChange(clientOverrides);
  }, [clientOverrides])




  const frequencyTemplate = (rowData: ClientOverride) => {
    return frequencies.find((frequency: any) => frequency.value === rowData.frequency)?.label;
  };
  const frequencyEditor = (options: ColumnEditorOptions) => {
    return (
      <Dropdown
        value={options.value}
        options={frequencies}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback!(e.value)}
        placeholder="Select a Frequency"
      />
    );
  };

  const clientTemplate = (rowData: ClientOverride) => {
    return clients.find((client: any) => client.id === rowData.client_id)?.name;
  };
  const clientEditor = (options: ColumnEditorOptions) => {
    const nonSelectedClients = clients
      .filter((client: any) => {
          const clientOverrideIds = clientOverrides.map((clientOverride: ClientOverride) => clientOverride.client_id);
          return client.id === options.rowData.client_id || !clientOverrideIds.includes(client.id);
      });
    return (
      <Dropdown
        value={options.value}
        options={nonSelectedClients}
        optionLabel="name"
        optionValue="id"
        onChange={(e) => options.editorCallback!(e.value)}
        placeholder="Select a Client"
      />
    );
  };



  const editTemplate = (rowData: ClientOverride) => {
    return <Button icon="pi pi-pencil" rounded text severity="secondary" aria-label="Edit" onClick={
      () => {
        setEditingRows({...editingRows, [rowData.client_id]: true});
      }
    } />
  };
  const editEditor = (options: ColumnEditorOptions) => {
    return (
        <Button icon="pi pi-check" rounded text severity="secondary" aria-label="Done"  onClick={
          () => {
            const newClientId = clientOverrides[options.rowIndex].client_id;
            setEditingRows({...editingRows, [newClientId]: undefined});

            clientOverrides[options.rowIndex] = options.rowData;
            setClientOverrides(clientOverrides);
          }
        } />
    );
  };

  const deleteTemplate = (rowData: ClientOverride) => {
    return <Button icon="pi pi-trash" rounded text severity="secondary" aria-label="Edit" onClick={
      () => {
        setClientOverrides(clientOverrides.filter((clientOverride: ClientOverride) => clientOverride.client_id !== rowData.client_id));
      }
    } />
  };
  const deleteEditor = (options: ColumnEditorOptions) => {
    return (
      <> </>
    );
  };

  const addNew = () => {
    // Can not add new overrides if there are existing ones being edited, otherwise a client might get added twice
    if(Object.values(editingRows).filter(val => !!val).length > 0) {
      props.toast.current.show({ severity: 'warn', summary: 'Finish any open client override edits', life: 3000 });
      return;
    }

    // Add the first client of none selected clients and set it to edit mode
    const nonSelectedClients = clients
      .filter((client: any) => {
        const clientOverrideIds = clientOverrides.map((clientOverride: ClientOverride) => clientOverride.client_id);
        return !clientOverrideIds.includes(client.id);
      });
    if(nonSelectedClients.length > 0) {
      setClientOverrides([
        ...clientOverrides,
        { client_id: nonSelectedClients[0].id, frequency: frequencies[0].value }
      ]);
      setEditingRows({...editingRows, [nonSelectedClients[0].id]: true});
    }
  }

  return (
    <div className="card p-fluid">
      <DataTable loading={loading} value={clientOverrides} editMode="row" dataKey="client_id"
                 editingRows={editingRows} onRowEditChange={()=>{}}
                 lazy size="small" scrollable scrollHeight="30vh"
      >
        <Column style={{ width: '55%' }} field="client_id" header="Client" body={clientTemplate} editor={(options) => clientEditor(options)}></Column>
        <Column style={{ width: '25%' }} field="frequency" header="Frequency" body={frequencyTemplate} editor={(options) => frequencyEditor(options)}></Column>

        <Column style={{ width: '5%' }} body={editTemplate} editor={(options) => editEditor(options)}></Column>
        <Column style={{ width: '5%' }} body={deleteTemplate} editor={(options) => deleteEditor(options)}></Column>
      </DataTable>
      <Button type="button" icon="pi pi-plus" label="Add override" className="p-button-outlined" size="small"
              style={{ fontSize: 'small', marginTop: 10, color: "#2dd36f", maxWidth: 200}}
              disabled={loading}  onClick={addNew} />
    </div>
  );

}